"use strict";import{tag as l}from"../custom-tag.js";export{setCustomTemplateLiteralTag}from"../custom-tag.js";export const RealTimeCustomerProfileIcon=({width:e=24,height:t=24,hidden:a=!1,title:r="Real Time Customer Profile"}={})=>l`<svg
    xmlns="http://www.w3.org/2000/svg"
    width="${e}"
    height="${t}"
    viewBox="0 0 36 36"
    aria-hidden=${a?"true":"false"}
    role="img"
    fill="currentColor"
    aria-label="${r}"
  >
    <path
      d="M18 1a17 17 0 1 0 17 17A17 17 0 0 0 18 1Zm10.982 27.183a10.826 10.826 0 0 0-6.224-3.128 1.307 1.307 0 0 1-1.131-1.311V21.85a1.313 1.313 0 0 1 .333-.844 9.99 9.99 0 0 0 2.28-6.236c0-4.72-2.508-7.36-6.287-7.36s-6.358 2.737-6.358 7.36a10.103 10.103 0 0 0 2.383 6.238 1.31 1.31 0 0 1 .334.845v1.883a1.3 1.3 0 0 1-1.14 1.31 10.863 10.863 0 0 0-6.24 3.042 15 15 0 1 1 22.05.094Z"
    />
  </svg>`;
//# sourceMappingURL=RealTimeCustomerProfile.js.map
